<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <div>
            <AmountSelectorSolomonConcert />           
          </div>
          <FormSection title="Personal Information">
            <FormRow inline class="israeli-tax-id-row">
              <FormCol field="taxId" label="Teudat Zehut" placeholder="Enter your Teudat Zehut" />
            </FormRow>
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>                   
            <!-- <FormRow>
                <input type="checkbox" @click="setValue('custom.isGapStudent', !isGapStudent)" :checked="isGapStudent" id="isGapStudent" class="checkbox-input"/>  <FormLabel for="isGapStudent"> Current gap year student</FormLabel>
              </FormRow>  -->
          </FormSection>
          <FormSection title="">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
            <!-- <div class="paytext">
              By entering and submitting my information, I understand and agree that this
              information will be shared with NCSY Israel, the Orthodox Union and Yeshiva
              University
            </div> -->
          </FormSection>

          <PaymentButton showAmount btnText="Pay now" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, onMounted } from "vue";
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  props: {
    subCampaign: String,
    campaign: String,
  },
  setup(props) {
    const { getValue, setValue, form, submit } = usePaymentForm();
    const isGapStudent = computed(() => getValue('custom.isGapStudent'))

    setValue("gateway", "SensepassCardcomPrograms");

    if (props.subCampaign) {
      setValue("applications.0.subCampaign", props.subCampaign);
    }

    if (props.campaign) {
      setValue("applications.0.campaign", props.campaign);
    }

    onMounted(() => {
      const params = queryParams();

      if (params.utm_content) {
        if (
          !["Direct Mail", "Telemarketing", "Text SMS Message"].includes(
            params.utm_content
          )
        ) {
          throw new Error("Invalid subcampaign");
        }

        setValue("applications.0.subCampaign", params.utm_content);
      }
    });

    return {
      form,
      getValue,
      setValue,
      submit,
      isGapStudent,
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep hr {
  display: block !important;
  border-color: #efefef !important;
  margin-top: 0 !important;
  margin-bottom: 30px !important;
}
.paytext {
  font-size: 14px;
  color: #222;
  padding-top: 0px;
  line-height: normal;
  padding-bottom: 10px;
  display: block;
}
#isGapStudent {
  margin-right: 5px;
}
::v-deep .payment span.flex span{
  display: flex;
}
</style>
